import { Select } from "antd";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { DropdownSuffix } from "icons";
import { useState } from "react";

export const Dropdown = ({ value, handleSelectOption, options }) => {
  const [open, setOpen] = useState(false);
  const { translator } = useLanguageTranslator();

  return (
    <Select
      open={open}
      onDropdownVisibleChange={setOpen}
      showSearch
      onChange={handleSelectOption}
      filterOption={(
        input,
        option, // 👈 filter logic
      ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
      // defaultValue={employees[0]?.value}
      style={{ width: "100%", height: "100%" }}
      value={value}
      options={options}
      suffixIcon={
        <DropdownSuffix
          style={{
            transform: open ? "rotate(180deg)" : "rotate(360deg)",
            transition: "all ease 0.3s",
          }}
        />
      }
      optionRender={(data) => (
        <div>{translator("emailNotes")[`${data.key}`]}</div>
      )}
      placeholder="Select"
    />
  );
};
